import {
  clearCandidate,
  setError,
  signOut,
} from "@/redux/slices/commonSlices/candidateSlice";

import {useCurrentRole} from "@hooks/CurrentRole";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {AvatarInitials} from "@ui/general/AvatarInitials/index";
import {BorderArticle} from "@ui/general/BorderArticle";
import {ChatDesc} from "@ui/general/ChatDesc";
import DropdownMenu from "@ui/general/DropdownMenu";
import {Logo} from "@ui/general/Logo";
import {RootIcon} from "@ui/icons/RootIcon";
import {H3} from "@ui/titles/H3";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";

import styles from "./styles.module.scss";

export const Header = () => {
  const currentRole = useCurrentRole();
  const {t} = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {isMobile} = useSelector((state) => state.common.settings);
  const {id, name, lastname, role, cover} = useSelector(
    (state) => state.common.candidate,
  );

  const adminMenuList = [
    {
      id: 0,
      iconId: "profile",
      name: t("header.menu.profile"),
      link: `/admin-panel/profile/${id}`,
    },
  ];

  const menuList = [
    {
      id: 0,
      iconId: "profile",
      name: t("header.menu.profile"),
      link:
        role !== "Representative"
          ? `/admin-panel/profile/${id}`
          : `/user-panel/profile/${id}`,
    },
    {
      id: 1,
      iconId: "chart",
      name: t("header.menu.history"),
      link:
        role !== "Representative"
          ? "/admin-panel/analytics/scenario"
          : "/user-panel/analytics/scenario",
    },
  ];

  const excludedPaths = [
    "simulations",
    "privacy",
    "terms",
    "disclaimer",
    "chat",
  ];

  const isExcludedPath = excludedPaths.some((path) =>
    location.pathname.includes(path),
  );

  const renderAvatar = () => {
    if (cover) {
      return (
        <img
          src={cover}
          alt={"avatar"}
        />
      );
    }
    return (
      <AvatarInitials
        name={name}
        lastName={lastname}
      />
    );
  };

  const handleClickLogout = async () => {
    const resultAction = await dispatch(signOut());

    if (signOut.fulfilled.match(resultAction)) {
      navigate("/login");

      dispatch(clearCandidate());
    } else {
      dispatch(setError(t("server_error.logout")));
    }
  };

  return (
    <div className={"container-big"}>
      <div className={styles.header}>
        <Logo />

        {location.pathname.includes("chat") && <ChatDesc />}

        {isExcludedPath || isMobile ? (
          <div className={styles.userInfoSmall}>
            <DropdownMenu
              head={<RootDesc>{name}</RootDesc>}
              list={role === "Admin" ? adminMenuList : menuList}
              top={35}
            >
              <div
                onClick={handleClickLogout}
                className={styles.userLogout}
              >
                <RootIcon id={"logout"} />

                <RootDesc>
                  <span className={"text-[var(--grey)]"}>
                    {t("header.logout")}
                  </span>
                </RootDesc>
              </div>
            </DropdownMenu>

            <div className={styles.userPhoto}>{renderAvatar()}</div>
          </div>
        ) : (
          <div className={"container-small"}>
            <BorderArticle>
              <div className={styles.userInfoBig}>
                <div className={styles.userProfile}>
                  <div className={styles.userPhoto}>{renderAvatar()}</div>

                  {role === "Admin" || role === "Manager" ? (
                    <DropdownMenu
                      head={<H3>{name}</H3>}
                      list={adminMenuList}
                      top={45}
                    />
                  ) : (
                    <H3>{name}</H3>
                  )}

                  <RootDesc>
                    <span className={"text-[var(--grey)]"}>
                      {currentRole(role)}
                    </span>
                  </RootDesc>
                </div>

                <div
                  onClick={handleClickLogout}
                  className={styles.adminLogout}
                >
                  <RootIcon id={"logout"} />

                  <RootDesc>
                    <span className={"text-[var(--grey)]"}>
                      {t("header.logout")}
                    </span>
                  </RootDesc>
                </div>
              </div>
            </BorderArticle>
          </div>
        )}
      </div>
    </div>
  );
};
